module.exports = __webpack_public_path__ + "static/media/var.09f8a4ca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/var.svg
// module id = 208
// module chunks = 0